import { logWrapper } from '../utils';

function ddMaxlengthDirectiveFactory(runtimeConstant) {
  function link(scope, element, attrs, ngModelCtrl) {
    const maxlength = Number(attrs.ddMaxlength);

    function fromUser(text) {
      if (text !== null && text !== undefined) {
        if (text.toString().length > maxlength) {
          const transformedInput = text.toString().substring(0, maxlength);
          ngModelCtrl.$setViewValue(transformedInput);
          ngModelCtrl.$render();
          return transformedInput;
        }
        return text;
      }
    }

    ngModelCtrl.$parsers.push(fromUser);
  }

  function run() {
    return {
      require: 'ngModel',
      link: link,
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const ddMaxlengthDirective = ['runtimeConstant', ddMaxlengthDirectiveFactory];
